import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { ContactAddPage } from '../contact-add/contact-add';
import { ContactEditPage } from '../contact-edit/contact-edit';
import { InvitePage } from '../invite/invite';
import { GroupViewPage } from '../group-view/group-view';
import { GroupPermissionsPage } from '../group-permissions/group-permissions';
import { ContactViewPage } from '../contact-view/contact-view';

@Component({
  selector: 'page-contacts',
  templateUrl: 'contacts.html'
})
export class ContactsPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }
  goToAddContact(params){
    if (!params) params = {};
    this.navCtrl.push(ContactAddPage);
  }goToContactEdit(params){
    if (!params) params = {};
    this.navCtrl.push(ContactEditPage);
  }goToInvite(params){
    if (!params) params = {};
    this.navCtrl.push(InvitePage);
  }goToGroupView(params){
    if (!params) params = {};
    this.navCtrl.push(GroupViewPage);
  }goToGroupPermissions(params){
    if (!params) params = {};
    this.navCtrl.push(GroupPermissionsPage);
  }goToContactView(params){
    if (!params) params = {};
    this.navCtrl.push(ContactViewPage);
  }stopPropagation(params){
    this.stopPropagation(params);
  }
}



// WEBPACK FOOTER //
// ./src/pages/contacts/contacts.ts